import { useNavigate } from "react-router-dom";
import useLang from "Shared/hooks/useLanguage";

const PaymentFailed = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <div>
      <div id="kt_app_toolbar" className="app-toolbar py-2 pt-lg-3">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <ul className="breadcrumb breadcrumb-separatorless fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <a href="" className="text-muted text-hover-primary">
                  {t("Home")}
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                {t("Supply Management")}
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                {t("Payment Failed")}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="app-container container-fluid">
        <div className="card mb-5">
          <div className="card-body py-15">
            <div className="text-center">
              <i
                className="bi bi-x-circle-fill text-danger mb-4 d-block"
                style={{ fontSize: "3rem" }}
                aria-hidden
              />
              <h3 className="fw-bold mb-3">{t("Payment Failed")}</h3>
              <p className="text-muted mb-6">
                {t(
                  "Your payment could not be completed. Please try again or return to Supply Orders."
                )}
              </p>
              <button
                type="button"
                className="btn btn-sm fw-bold btn-primary"
                onClick={() => navigate("/manage-order")}
              >
                {t("Go to Supply Orders")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
